define('TescoMobile_Checkout/js/form/element/checkbox-set',['underscore', 'mageUtils', 'Magento_Ui/js/form/element/checkbox-set'], function (_, utils, Parent) {
  'use strict';

  return Parent.extend({
    defaults: {
      options: [],
      multiple: false,
      multipleScopeValue: null
    },
    initConfig: function () {
      this._super().observe('options error disabled focused preview visible value warn notice isDifferedFromDefault').observe('isUseDefault serviceDisabled');
      this.value = this.normalizeData(this.value);
      return this;
    },
    initLinks: function () {
      this.multipleScopeValue = undefined;
      return this._super();
    },
    setOptions: function (values) {
      this.options(values);
      return this;
    }
  });
});

